import { render, staticRenderFns } from "./use-cases-international.vue?vue&type=template&id=cf281a84&scoped=true"
import script from "./use-cases-international.vue?vue&type=script&lang=js"
export * from "./use-cases-international.vue?vue&type=script&lang=js"
import style0 from "./use-cases-international.vue?vue&type=style&index=0&id=cf281a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf281a84",
  null
  
)

export default component.exports